import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit, Optional, Inject, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { convertToNgbDate, datePickerMinDate,  noWhitespaceInRequiredValidator } from '../../../shared/constants';
import { noop } from 'jquery';
import { NavbarComponent } from '../../../navbar/navbar.component';
import Swal from 'sweetalert2';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { environment } from '../../../../environments/environment';
import moment from 'moment';
import { startWith } from 'rxjs';
import { addDays } from 'date-fns';

@Component({
	selector: 'app-leave-balance-form',
	templateUrl: './leave-balance-form.component.html',
	styleUrl: './leave-balance-form.component.scss'
})
export class LeaveBalanceFormComponent {
	File_Storage_URL = environment.File_Storage_URL;
	moduleForm: FormGroup = this.formBuilder.group({
		emp_code: [null, [Validators.required]],
		lb: [null, [Validators.required, Validators.pattern(/^[+-]?([0-9]*[.])?[0-9]+$/)]],
	});
	showLoader = false;
	pageLoading1 = false;
	userList: any[] = [];
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	formSubmitted = false;
	modalId = "leaveBalanceModal" + this.getRandom5DigitNumber();
	getRandom5DigitNumber() {
		return Math.floor(Math.random() * 90000) + 10000;
	}

	constructor(private cd: ChangeDetectorRef, private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) { }

	initForm(emp: any) {
		this.resetForm();
		this.formSubmitted = false;
		if (emp) {
			this.f.emp_code.setValue(emp.emp_code);
			this.f.lb.setValue(emp.lb);
		}
		this.openModal();
		this.apiService.userList$.subscribe((userList) => {
			if (userList) {
				this.userList = userList.filter((u) => u.emp_code);
				this.cd.detectChanges();
			}
		});
	}

	empChanged() {
		if (this.f.emp_code.value) {
			let emp = this.userList.find((u) => u.emp_code == this.f.emp_code.value);
			this.f.lb.setValue(emp.lb);
		}
	}

	get f() { return this.moduleForm.controls; }

	clearForm() {
		this.resetForm();
		this.formSubmitted = false;
		this.cleared.emit();
		$("#" + this.modalId).modal("hide");
	}

	resetForm() {
		this.moduleForm.reset();
	}

	openModal() {
		$("#" + this.modalId).modal("show");
	}

	saveData() {
		this.formSubmitted = true;
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const data: any = {
			emp_code: this.f.emp_code.value,
			lb: this.f.lb.value,
		};
		this.showLoader = true;
		this.apiService.setLeaveBalance(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.cd.detectChanges();
				this.toastr.success("Saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				this.cd.detectChanges();
				if (error.status == 401) { return }
				let errorMsg = error.error;
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}
}
